module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/icon_trash_48x48_hover.d8eb4bff.svg";